export default class Nav {
	constructor() {
		this.$toggle = $('.js-nav-toggle');
		this.$wrap = $('.js-nav-wrap');
		this.$subToggle = $('.js-nav-sub-toggle');
		this.activeClass = 'js-is-active';
	}

	onClick(event) {
		const $elm = $(event.currentTarget);

		$elm.toggleClass(this.activeClass);
		this.$wrap.toggleClass(this.activeClass);
		$('html,body').toggleClass('no-scroll');
	}

	onSubClick(event) {
		const $elm = $(event.currentTarget);
		const $menu = $elm.closest('li').find('ul');

		$elm.toggleClass(this.activeClass);
		$menu.slideToggle(300);

		return false;
	}

	setEventBindings() {
		this.$toggle.on('click', this.onClick.bind(this));

		this.$subToggle.on('click', this.onSubClick.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/Nav.js